/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { OrganizationStrictHttpResponse } from '../../organization-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OnboardingTemplateModel } from '../../models/onboarding-template-model';

export interface AdminOnboardingTemplateIdGet$Params {
  id: string;
}

export function adminOnboardingTemplateIdGet(http: HttpClient, rootUrl: string, params: AdminOnboardingTemplateIdGet$Params, context?: HttpContext): Observable<OrganizationStrictHttpResponse<OnboardingTemplateModel>> {
  const rb = new RequestBuilder(rootUrl, adminOnboardingTemplateIdGet.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as OrganizationStrictHttpResponse<OnboardingTemplateModel>;
    })
  );
}

adminOnboardingTemplateIdGet.PATH = '/Admin/OnboardingTemplate/{id}';
